import React from "react";
import Link from "next/link";
import TypographyPoppins from "../TypographyPoppins";
import { FRONTEND_ENDPOINTS } from "../../../public/Constants/endpoints";

const ProfileMenuUserName = ({ firstName, lastName }) => {
    const initials = `${firstName?.[0]?.toUpperCase()}${lastName?.[0]?.toUpperCase()}`;

    return (
        <div className="w-full flex gap-[10px] rounded bg-LIGHT_PINK items-center px-5 py-[30px]">
            <div className="w-10 h-10 rounded-full border border-Primary_Default flex items-center justify-center">
                <TypographyPoppins
                    size={"base"}
                    fontWeight={"normal"}
                    text={initials}
                />
            </div>
            <div>
                <div className="flex gap-1">
                    <TypographyPoppins
                        size={"base"}
                        fontWeight={"normal"}
                        text={`${firstName} ${lastName}`}
                        customStyle={"!capitalize"}
                    />
                </div>
                <TypographyPoppins
                    size={"xs"}
                    fontWeight={"light"}
                    text={"Hope your day is going good!"}
                    customStyle={""}
                />
            </div>
        </div>
    );
};

export default ProfileMenuUserName;
